import React from 'react'
import { Pill } from '../../ui'

// Maps session status to a Pill tone
const STATUS_TONE = {
  draft: 'neutral',
  ready: 'info',
  'in-session': 'success',
  completed: 'neutral',
  cancelled: 'neutral',
}

// Human-readable status labels
const STATUS_LABEL = {
  draft: 'Draft',
  ready: 'Ready',
  'in-session': 'In session',
  completed: 'Completed',
  cancelled: 'Cancelled',
}

/**
 * CanvasHeader — top chrome for the session canvas.
 *
 * Props:
 *   session       object  — session object with at least { status, scheduledAt }
 *   reportName    string  — display name of the session owner (report or self)
 *   action        node    — status-specific action button slot (Share / Complete / etc.)
 */
export function CanvasHeader({ session, reportName, action }) {
  const status = session?.status ?? 'draft'
  const scheduledAt = session?.scheduledAt
  const tone = STATUS_TONE[status] ?? 'neutral'
  const label = STATUS_LABEL[status] ?? status

  const dateStr = scheduledAt
    ? new Date(scheduledAt).toLocaleDateString(undefined, { dateStyle: 'medium' })
    : null

  return (
    <header className="canvas-header" data-testid="canvas-header">
      <div className="canvas-header__left">
        <h1 className="canvas-header__title">
          {reportName ? `${reportName}'s 1:1` : '1:1 session'}
        </h1>
        {dateStr && (
          <time
            className="canvas-header__date"
            dateTime={scheduledAt}
          >
            {dateStr}
          </time>
        )}
      </div>
      <div className="canvas-header__right">
        <Pill tone={tone} className="canvas-header__status-pill">
          {label}
        </Pill>
        {action && (
          <div className="canvas-header__action">{action}</div>
        )}
      </div>
    </header>
  )
}
